import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ReportsService } from './reports.service';
import * as XLSX from 'xlsx';
import { LogoutService } from '../../../auth/components/auth/auth.service';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SwiperComponent } from "swiper/angular";
import { ChartConfiguration } from 'chart.js';

import SwiperCore, {
  Keyboard,
  Pagination,
  Navigation,
  Virtual,
  SwiperOptions,
} from 'swiper';
SwiperCore.use([Keyboard, Pagination, Navigation, Virtual]);
@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
})
export class ReportsComponent implements OnInit {
  userName: string = '';
  password: string = '';
  isError: any = {
    status: false,
    message: '',
  };
  width: any = screen.width;
  dataSource: any = [];
  displayedColumns: string[] = [
    'brand',
    'location',
    'name',
    'programName',
    'startDate',
    'completedDate',
    'completionPercent',
    'scorePercent',
  ];

  reportsData: any;

  config: SwiperOptions = {
    slidesPerView: 5,
    spaceBetween: 50,
    navigation: true,
    pagination: { clickable: true },
    scrollbar: { draggable: true },
  };

  @ViewChild('swiper', { static: false }) swiper?: SwiperComponent;
  @ViewChild('TABLE') table!: ElementRef;

  @ViewChild(MatSort)
  sort!: MatSort;
  permissions = [];

  brands: any[] = [];
  countries: any[] = [];
  states: any[] = [];
  areas: any[] = [];
  clusters: any[] = [];
  stores: any[] = [];
  programs: any[] = [];

  selectedBrand = 'ALL';
  selectedCountry = 'ALL';
  selectedState = 'ALL';
  selectedArea = 'ALL';
  selectedCluster = 'ALL';
  selectedStore = 'ALL';

  accessLevels: any = {};
  selectedProgram = 'ALL';

  public barChartLegend = true;
  public progressChartData: ChartConfiguration<'bar'>['data'] = {
    labels: [],
    datasets: [
      { data: [], label: 'Progress (%)' }
    ]
  };
  public scoreChartData: ChartConfiguration<'bar'>['data'] = {
    labels: [],
    datasets: [
      { data: [], label: 'Score (%)' }
    ]
  };
  public barChartOptions: ChartConfiguration<'bar'>['options'] = {
    responsive: false,
  };

  hierarchy = ['brand', 'country', 'state', 'area', 'cluster', 'store', 'program'];
  currentGraphHierarchyLevel = 0;
  constructor(private ReportsService: ReportsService) { }

  getOrgId() {
    return localStorage.getItem('orgId');
  }

  getReportData(type?: string) {
    const orgId = this.getOrgId();
    let params = '';
    if (this.selectedBrand && this.selectedBrand !== 'ALL') {
      params += `&brand=${this.selectedBrand}`;
    }
    if (this.selectedCountry && this.selectedCountry !== 'ALL') {
      params += `&country=${this.selectedCountry}`;
    }
    if (this.selectedState && this.selectedState !== 'ALL') {
      params += `&state=${this.selectedState}`;
    }
    if (this.selectedArea && this.selectedArea !== 'ALL') {
      params += `&area=${this.selectedArea}`;
    }
    if (this.selectedCluster && this.selectedCluster !== 'ALL') {
      params += `&cluster=${this.selectedCluster}`;
    }
    if (this.selectedStore && this.selectedStore !== 'ALL') {
      params += `&store=${this.selectedStore}`;
    }
    this.ReportsService.getReportsData(orgId, params).then(
      (reportData: any) => {
        reportData.data.programs.unshift({ name: "ALL" });
        if (!type) {
          this.reportsData = reportData.data;
        } else {
          this.getReportsDataWithType(type, reportData.data);
        }
        this.checkForAllBrandsAccess(reportData.data);
        if(!type) {
          if(this.brands.length > 1) {
            this.setGraphData(0);
          } else {
            this.setGraphData(1);
          }
        }
        this.dataSource = new MatTableDataSource<any>(reportData.data.users);
        this.dataSource.sort = this.sort;
      }
    );
  }

  checkForAllBrandsAccess(reportsData: any) {
    const accessLevelsBrands = Object.keys(this.accessLevels);
    if (accessLevelsBrands.includes('brand') && !this.brands.length) {
      this.brands.push({ brand: "ALL", accessValues: [] });
      reportsData.brandList.forEach((brand: any) => {
        this.brands.push({ brand, accessValues: [] });
      });
    }
  }

  getReportsDataWithType(type: string, data: any) {
    switch (type) {
      case 'brand':
        this.reportsData['countryList'] = data.countryList;
        this.reportsData['stateList'] = data.stateList;
        this.reportsData['areaList'] = data.areaList;
        this.reportsData['clusterList'] = data.clusterList;
        this.reportsData['storeList'] = data.storeList;
        this.reportsData['users'] = data.users;
        this.setGraphData(1);
        break;
      case 'country':
        this.reportsData['countryList'] = data.countryList;
        this.reportsData['stateList'] = data.stateList;
        this.reportsData['areaList'] = data.areaList;
        this.reportsData['clusterList'] = data.clusterList;
        this.reportsData['storeList'] = data.storeList;
        this.reportsData['users'] = data.users;
        this.setGraphData(2);
        break;
      case 'state':
        // this.reportsData['stateList'] = data.stateList;
        this.reportsData['areaList'] = data.areaList;
        this.reportsData['clusterList'] = data.clusterList;
        this.reportsData['storeList'] = data.storeList;
        this.reportsData['users'] = data.users;
        this.setGraphData(3);
        break;
      case 'area':
        // this.reportsData['areaList'] = data.areaList;
        this.reportsData['clusterList'] = data.clusterList;
        this.reportsData['storeList'] = data.storeList;
        this.reportsData['users'] = data.users;
        this.setGraphData(4);
        break;
      case 'cluster':
        // this.reportsData['clusterList'] = data.clusterList;
        this.reportsData['storeList'] = data.storeList;
        this.reportsData['users'] = data.users;
        this.reportsData['users'] = data.users;
        this.setGraphData(5);
        break;
      case 'store':
        this.reportsData['users'] = data.users;
        this.setGraphData(6);
        break;
    }
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  ExportTOExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      this.table.nativeElement
    );
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'Report.xlsx');
  }

  ngOnInit(): void {
    this.shorGif();
    this.shorOpacity();
    this.permissions = this.ReportsService.getReportsPermissions();
    if (this.permissions?.length) {
      this.permissions.forEach((permission: any) => {
        const index = this.brands.findIndex(
          (b) => b.brand === permission.brand
        );
        if (index != -1) {
          this.brands[index].accessValues.push(permission.accessValue);
        } else {
          if (permission.brand) {
            this.brands.push({
              brand: permission.brand,
              accessValues: [permission.accessValue],
            });
          }
        }
        this.accessLevels[permission.brand || 'brand'] = permission.accessLevel;
      });
      if (this.brands.length > 0) {
        this.selectedBrand = this.brands[0].brand;
      }
      this.checkInitialAccessValue();
      this.getReportData();
    }
  }

  checkInitialAccessValue() {
    if (!this.brands.length) return;
    const accessLevel = this.accessLevels[this.selectedBrand];
    const accessValue = this.brands.filter((b) => b.brand === this.selectedBrand)[0].accessValues[0];
    switch (accessLevel) {
      case 'brand':
        this.selectedBrand = accessValue;
        break;
      case 'country':
        this.selectedCountry = accessValue;
        break;
      case 'state':
        this.selectedState = accessValue;
        break;
      case 'area':
        this.selectedArea = accessValue;
        break;
      case 'cluster':
        this.selectedCluster = accessValue;
        break;
      case 'store':
        this.selectedStore = accessValue;
        break;
    }
  }

  getDataLists(type: string) {
    let list: any[] = [];
    switch (type) {
      case 'brand':
        this.brands.forEach(brand => {
          list.push(brand.brand);
        });
        break;

      case 'program':
        this.reportsData.programs.forEach((program: any) => {
          list.push(program.name);
        });
        break;

      default:
        if (this.accessLevels[this.selectedBrand] === type) {
          list = this.brands.filter((b) => b.brand === this.selectedBrand)[0].accessValues;
        } else {
          list = this.reportsData && this.reportsData[`${type}List`] ? ['ALL', ...this.reportsData[`${type}List`]] : [];
        }
        break;
    }
    list = this.sortArray(list);
    return list;
  }

  getPrograms() {
    return this.reportsData.programs;
  }

  onChangeValue(ev: any, type: string) {
    switch (type) {
      case 'brand':
        this.selectedBrand = ev.value;
        this.selectedCountry = 'ALL';
        this.selectedState = 'ALL';
        this.selectedArea = 'ALL';
        this.selectedCluster = 'ALL';
        this.selectedStore = 'ALL';
        this.selectedProgram = 'ALL';
        this.checkInitialAccessValue();
        break;
      case 'country':
        this.selectedCountry = ev.value;
        this.selectedState = 'ALL';
        this.selectedArea = 'ALL';
        this.selectedCluster = 'ALL';
        this.selectedStore = 'ALL';
        this.selectedProgram = 'ALL';
        break;
      case 'state':
        this.selectedState = ev.value;
        this.selectedArea = 'ALL';
        this.selectedCluster = 'ALL';
        this.selectedStore = 'ALL';
        this.selectedProgram = 'ALL';
        break;
      case 'area':
        this.selectedArea = ev.value;
        this.selectedCluster = 'ALL';
        this.selectedStore = 'ALL';
        this.selectedProgram = 'ALL';
        break;
      case 'cluster':
        this.selectedCluster = ev.value;
        this.selectedStore = 'ALL';
        this.selectedProgram = 'ALL';
        break;
      case 'store':
        this.selectedStore = ev.value;
        this.selectedProgram = 'ALL';
        break;
    }
    this.getReportData(type);
  }

  onChangeProgram(ev: any) {
    this.selectedProgram = ev.value;
    let users = this.reportsData.users;
    if (this.selectedProgram && this.selectedProgram !== 'ALL') {
      users = this.reportsData.users.filter((user: any) => (user.programName).trim() === this.selectedProgram);
    }
    this.dataSource = new MatTableDataSource<any>(users);
    this.dataSource.sort = this.sort;
  }

  isAccessAvailable(type: string) {
    let available = false;
    if (this.selectedBrand === 'ALL') return true;
    if (!this.accessLevels[this.selectedBrand]) return true;
    switch (type) {
      case 'brand':
        available = this.accessLevels[this.selectedBrand] === 'brand';
        break;
      case 'country':
        available = ['brand', 'country'].includes(this.accessLevels[this.selectedBrand]);
        break;
      case 'state':
        available = ['brand', 'country', 'state'].includes(
          this.accessLevels[this.selectedBrand]
        );
        break;
      case 'area':
        available = ['brand', 'country', 'state', 'area'].includes(
          this.accessLevels[this.selectedBrand]
        );
        break;
      case 'cluster':
        available = ['brand', 'country', 'state', 'area', 'cluster'].includes(
          this.accessLevels[this.selectedBrand]
        );
        break;
      case 'store':
        available = ['brand', 'country', 'state', 'area', 'cluster', 'store'].includes(
          this.accessLevels[this.selectedBrand]
        );
        break;
    }
    return available;
  }

  announceSortChange(ev: any) {
    this.dataSource.sort = this.sort;
  }

  shorGif() {
    if (this.width <= 600) {
      setTimeout(function () {
        (<HTMLInputElement>document.getElementById('loadinfIf')).style.display =
          'none';
        setTimeout(function () {
          (<HTMLInputElement>(
            document.getElementById('loadinfIf')
          )).style.display = 'none';
        }, 7000);
      }, 7000);
    } else {
    }
  }

  shorOpacity() {
    if (this.width <= 600) {
      setTimeout(function () {
        (<HTMLInputElement>document.getElementById('opacity')).style.display =
          'none';
        setTimeout(function () {
          (<HTMLInputElement>document.getElementById('opacity')).style.display =
            'none';
        }, 7000);
      }, 7000);
    } else {
    }
  }

  sortArray(array: any[]): any {
    array.sort((a: any, b: any) => {
      if (a < b) {
        return -1;
      } else if (a > b) {
        return 1;
      } else {
        return 0;
      }
    });
    return array;
  }

  getGraphLevelIdx(levelIdx: number) {
    if(this.isAllSelectedValues()) return 0;
    let finalLevelIdx = -1;
    for (let index = levelIdx; index < this.hierarchy.length; index++) {
      const type = this.hierarchy[index];
      const list = this.getDataLists(type);
      if(list.length > 1 && this.isAccessAvailable(type)) {
        finalLevelIdx = index;
        break;
      }
    }
    if(finalLevelIdx === -1) {
      finalLevelIdx = this.hierarchy.length - 1;
    }
    return finalLevelIdx;
  }

  isAllSelectedValues() {
    return this.selectedBrand === "ALL" && this.selectedCountry === "ALL" && this.selectedState === "ALL" && this.selectedArea === "ALL" && this.selectedStore === "ALL" && this.selectedProgram === "ALL";
  }

  clearChartData() {
    this.progressChartData.labels = [];
    this.progressChartData.datasets[0].data = [];
    this.scoreChartData.labels = [];
    this.scoreChartData.datasets[0].data = [];
  }

  setGraphData(idx: number) {
    // console.log('setGraphData...');
    this.clearChartData();
    const levelIdx = this.getGraphLevelIdx(idx);
    const type = this.hierarchy[levelIdx];
    let labels: string[] = [];
    let progressDataset: number[] = [];
    let scoreDataset: number[] = [];
    switch (type) {
      case 'brand':
        this.brands.forEach(brand => {
          if (brand.brand !== "ALL") {
            labels.push(brand.brand);
          }
        });
        labels.forEach(label => {
          progressDataset.push(this.getTotalProgressForGraph('brand', label, 'completionPercent'));
          scoreDataset.push(this.getTotalProgressForGraph('brand', label, 'scorePercent'));
        });
        break;
      case 'program':
        this.reportsData.programs.forEach((program: any) => {
          if (program.name !== "ALL") {
            labels.push(program.name);
          }
        });
        labels.forEach(label => {
          progressDataset.push(this.getTotalProgressForGraph('programName', label, 'completionPercent'));
          scoreDataset.push(this.getTotalProgressForGraph('programName', label, 'scorePercent'));
        });
        break;

      default:
        labels = this.getDataLists(type);
        labels = labels.filter(label => label !== "ALL");
        labels.forEach(label => {
          progressDataset.push(this.getTotalProgressForGraph(type, label, 'completionPercent'));
          scoreDataset.push(this.getTotalProgressForGraph(type, label, 'scorePercent'));
        });
        break;
    }
    this.progressChartData.labels = labels;
    this.progressChartData.datasets[0].data = progressDataset;
    this.scoreChartData.labels = labels;
    this.scoreChartData.datasets[0].data = scoreDataset;
  }

  getTotalProgressForGraph(key: string, value: string, type: string) {
    let total = 0;
    let usersCount = 0;
    this.reportsData.users.forEach((user: any) => {
      if (user[key === 'store' ? 'location' : key] === value) {
        if(type === 'completionPercent') {
          usersCount += 1;
          total += user[type];
        } else {
          if(user[type]) {
            usersCount += 1;
            total += user[type];
          }
        }
      }
    });
    return (total / usersCount);
  }
}
